import { Flex } from '@mixins';
import styled, { css } from 'styled-components';

export const DragDropZone = styled(Flex)`
  ${({ isDragActive, theme }) => css`
    border: 1px dashed ${theme.color.gray[100]};
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    background-color: ${isDragActive ? theme.color.mintMinded[50] : 'transparent'};

    &:hover {
      border-color: ${theme.color.mintMinded[900]};
    }
  `}
`;

export const FileItemContainer = styled(Flex)`
  ${({ status, theme }) => css`
    border: 1px solid ${status === 'failed' ? theme.color.red : theme.color.gray[100]};
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 12px;
    align-items: center;
  `}
`;

const getStatusIconBackgroundColor = (status, theme) => {
  if (status === 'failed') {
    return theme.color.red;
  }
  return theme.color.mintMinded[200];
};

export const StatusIcon = styled(Flex)`
  ${({ status, theme }) => css`
    width: 33px;
    height: 40px;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    background-color: ${getStatusIconBackgroundColor(status, theme)};
  `}
`;

export const ProgressBar = styled.div`
  ${({ progress, status, theme }) => css`
    width: 100%;
    max-width: 435px;
    height: 7px;
    border-radius: 100px;
    overflow: hidden;
    margin-top: 8px;
    align-self: flex-start;
    background-color: ${theme.color.gray[100]};

    &::after {
      content: '';
      display: block;
      height: 100%;
      width: ${progress}%;
      background-color: ${status === 'failed' ? theme.color.red : theme.color.mintMinded[300]};
      transition: width 0.3s ease;
    }
  `}
`;
